import { setApplicationStateById } from '@/contexts/ApplicationContext/ApplicationContext';

export const setLoading = (setState: setApplicationStateById) => (value: boolean) => {
  setState('SET_LOADING', (s) => ({
    ...s,
    loading: value,
  }));
};
